







/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/ban-ts-ignore */

import {Component, Vue} from 'vue-property-decorator';
import {mapGetters}     from "vuex";
import {Feature}        from "openlayers";
// @ts-ignore
import {createStyle}    from 'vuelayers/lib/ol-ext';

@Component({
    computed: {
        ...mapGetters({
            geojson: 'mapProjectGeojson',
            zoom   : 'mapZoom',
        }),
    },
})
export default class ProjectPoints extends Vue {
    makeClusterStyleFunc() {
        const cache: any = {};

        return function __clusterStyleFunc(feature: Feature) {
            const servicesCount = feature.getProperties().servicesCount.toString()
            let style           = cache[servicesCount]

            if (!style) {
                style = createStyle({
                    imageRadius    : 20,
                    strokeWidth    : 5,
                    strokeRadius   : 20,
                    strokeColor    : '#ff0000',
                    fillColor      : '#fff',
                    text           : servicesCount,
                    textFillColor  : '#4D4D4D',
                    textFontSize   : 17,
                    textStrokeWidth: 3,
                    textStrokeColor: '#fff',
                })

                cache[servicesCount] = style
            }

            return [style]
        }
    }

}
